import axios from '@/utils/request'
// 获取首页数据看板
export const getIndex = (params)=>{
  return axios.request({
     url: '/v1/index/index',
     method: 'get',
     params
   })
 };

// 获取首页数据看板列表
export const getIndexList = (params)=>{
  return axios.request({
     url: '/v1/index/list',
     method: 'get',
     params
   })
 };

 // 获取首页数据看板修改
export const setIndexList = (data)=>{
  return axios.request({
     url: '/v1/index/update',
     method: 'post',
     data
   })
 };
 // 获取应用面板列表
 export const getPanelLists = (params)=>{
  return axios.request({
     url: '/v1/appsServe/panelLists',
     method: 'get',
     params
   })
 };

 